import cartResx from 'Resx/Cart/Cart.resx';

export default class CurrencyDTO {
    constructor({ Code, Symbol, Name }) {
        this.code = Code;
        this.symbol = Symbol;
        this.name = Name;
    }

    toJSON() {
        return this.valueOf();
    }

    valueOf() {
        return ''.concat(
            this.code.charCodeAt(0),
            this.code.charCodeAt(1),
            this.code.charCodeAt(2)
        );
    }

    toString() {
        return this.symbol;
    }

    toOriginal() {
        return {
            Code: this.code,
            Symbol: this.symbol,
            Name: this.name
        };
    }

    static parse(args) {
        return args ? new CurrencyDTO(args) : null;
    }

    get currencyCodeTranslate() {
        const codeTranslates = {
            UAH: cartResx.UAHCode,
            EUR: cartResx.EURCode,
            PLN: cartResx.PLNCode
        };

        return codeTranslates[this.code] || this.code;
    }
}
